<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="handleSideBarHide()"
           [style]="{width:'700px'}">

    <ng-template pTemplate="header">{{categoryId ? 'Edit Category' : 'Add Category'}}</ng-template>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 220px)'}"
                   [styleClass]="'app-scrollpanel'">
        <div style="padding: 10px">
            <div class="field">
                <div>Image</div>

                <div style="margin-right: 10px">
                    <a href="{{category.ImageUrl}}" target="_blank">
                        <img style="max-width: 260px" src="{{category.ImageUrl}}" />
                    </a>
                </div>
                <div>
                    <input id="idImgInput"
                           type="file"
                           accept="image/*"
                           style="display: none"
                           (change)="handleImageChange($event)" />

                    <button pButton
                            type="button"
                            label="Upload"
                            class="edit-categ-btn"
                            icon="pi pi-upload"
                            (click)="handleUploadClick()"></button>
                </div>
            </div>

            <div class="field">
                <div>Name</div>
                <input pInputText class="edit-categ-field" [(ngModel)]="category.Name" />
            </div>
            <div class="field">
                <div>Description</div>
                <input pInputText class="edit-categ-field" [(ngModel)]="category.Description" />
            </div>
            <div class="field">
                <div>DisplayOrder</div>
                <p-inputNumber [(ngModel)]="category.DisplayOrder"
                               [style]="{width: '100%'}"
                               [inputStyle]="{width: '100%'}"></p-inputNumber>
            </div>
        </div>
    </p-scrollPanel>

    <hr style="margin-left: -1rem; margin-right: -1rem;" />

    <div class="flex-row" style="padding-left: 10px; padding-right: 10px">
        <div>
            <button pButton
                    type="button"
                    label="Cancel"
                    class="p-button-danger"
                    (click)="handleSideBarHide()"></button>
        </div>

        <div class="filler"></div>

        <div>
            <button pButton
                    type="button"
                    label="{{categoryId ? 'Save' : 'Create'}}"
                    class="edit-categ-btn"
                    (click)="handleSaveClick()"></button>
        </div>
    </div>
</p-sidebar>

<p-toast position="top-right"></p-toast>
